export default __webpack_public_path__ + "static/media/iconGreat.689988a5.svg";